/**
 * Created by Victor Rojo on 12/6/18.
 */
import { Component, OnInit }  from '@angular/core';
import { FormGroup, FormControl,
  FormBuilder, Validators }  from '@angular/forms';
import { Router, ActivatedRoute, Params }                   from '@angular/router';
import { NotificationsService }     from 'angular2-notifications';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation, NgxGalleryImageSize } from 'ngx-gallery';
import { BsModalService } from 'ngx-bootstrap/modal';



import { I18NService }      from "../shared/i18n/i18n.service";
import {NotificationService} from "./notification.service";

@Component({
  templateUrl: './notification-detail.component.html',
})
export class NotificationDetailComponent {

  tableMessages: any;
  isLoading = true;
  notification: any;
  galleryImages: any;
  galleryOptions: any;

  constructor(private router: Router,
              private route1: ActivatedRoute,
              private notificationService: NotificationService,
              private i18nService: I18NService,
              private modalService: BsModalService,
              private displayNotificationService: NotificationsService){

    //this.route1.params.subscribe((params: Params) => { this.onRouteParamsChange(params) });
    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");

    this.galleryOptions = [
      {
        width: '800px',
        height: '600px',
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
        previewCloseOnEsc: true,
        previewKeyboardNavigation: true,
        imageSize: NgxGalleryImageSize.Contain
      },
    ];
  }

  loadNotification(id:string):Promise<any> {
    return this.notificationService.get(id)
                  .then( notification => {
                    this.notification = notification;
                    this.isLoading = false;
                    if ( notification.screenShots ) {
                      this.galleryImages = notification.screenShots
                        .split(",")
                        .map((s:string) => {
                          return {
                            small: "api/v1/notification/screenshot/" + s,
                            medium: "api/v1/notification/screenshot/" + s,
                            big: "api/v1/notification/screenshot/" + s}
                        });
                    }
                  })
                  .catch( error => {
                    this.isLoading = false;
                    return Promise.reject(error.error || error)
                  });
  }

  hide() {
    this.modalService.hide(1);
  }

  //onRouteParamsChange(params: Params){
  //  let recordId = params["id"];
  //  if ( recordId ){
  //    this.notificationService.get(recordId)
  //      .then( notification => {
  //        this.notification = notification;
  //        this.isLoading = false;
  //        this.galleryImages = notification.screenShots
  //                                          .split(",")
  //                                          .map((s:string) => {
  //                                            return {
  //                                              small: "api/v1/notification/screenshot/" + s,
  //                                              medium: "api/v1/notification/screenshot/" + s,
  //                                              big: "api/v1/notification/screenshot/" + s}
  //                                          });
  //      })
  //      .catch( error => {
  //        this.isLoading = false;
  //      });
  //  }
  //}
}
